import { isFormPreviewPath } from './public-form.helper';

// Pages rendered inside someone else's chrome with no consent UI of their
// own: the Sponge ATS embeds (/embed/...) and the configuration-panel form
// previews. No consent is recorded on them, so no non-essential scripts load
// there either. The legacy ATS custom tab (/iframe, loaded by Bullhorn in a
// cross-site iframe) is deliberately not here: it keeps the banner and
// CookieConsentService persists the choice with a partitioned cookie instead.
const EMBEDDED_PATH = /^\/embed(\/|$)/;

export function isConsentSuppressedPath(
  pathname: string = window.location.pathname
): boolean {
  return EMBEDDED_PATH.test(pathname) || isFormPreviewPath(pathname);
}
